import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Link, useHistory, useParams } from "react-router-dom";
import useSocket from "use-socket.io-client";
import {
  useAppGuestUserIdSelector,
  useAppUserDetailsSelector,
  useAppUserTokenSelector,
} from "src/_common/hooks/selectors/userSelector";
import {
  useAppEventStatusMessageSelector,
  useAppGameDetailsSelector,
  useAppIrStatusMessageSelector,
  useAppSiteHeaderSelector,
} from "src/_common/hooks/selectors/eventSelector";
import {
  URLS,
  STORAGE,
  SELECTED_EVENT_STORAGE,
  INSIDERODEO_EVENT_STORAGE,
  detectDevice,
  IS_SHOWING_ADD_TO_HOME_SCREEN_IOS,
  CRYPTO_SECRET_KEY,
  APPLICATION_GLOBAL_SLUG,
  APPLICATION_VERSION,
} from "src/_config";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { SOCKET_CHANNEL, SOCKET_URL, RODEO_PAGE_NAME } from "src/_config";
import GuestSaveVoteModal from "../events/modal/guestSaveVoteModal";
import StatusModal from "../events/modal/statusModal";
import CouponModal from "../events/modal/couponModal";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import UpdateDisplayNameModal from "../events/modal/updateDisplayNameModal";
import VideoModal from "../events/modal/videoModal";
import TopSection from "./TopSection";
import SideMenus from "./SideMenus";
interface SideBarProps {
  page: string;
}

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

function Sidebar({ page }: SideBarProps) {
  const siteHeader = useAppSiteHeaderSelector();
  const history = useHistory();
  const userDetails = useAppUserDetailsSelector();
  const statusMessageSelector = useAppEventStatusMessageSelector();
  const irStatusMessageSelector = useAppIrStatusMessageSelector();
  const userAction = useAppUserAction();
  const eventAction = useAppEventAction();
  const userApi = useUserApi();
  const toast = useToaster();
  // const guestUserId = useAppGuestUserIdSelector()
  const [showGuestSaveVoteModal, setShowGuestSaveVoteModal] = useState<boolean>(false);

  const { eventId, performanceId } = useParams<any>();
  const [appRedirectData, setAppRedirectData] = useState<any>();
  const [showStatusModal, setShowStatusModal] = useState<boolean>(false);
  const [showCouponModal, setShowCouponModal] = useState<boolean>(false);
  const [couponData, setCouponData] = useState<any>();
  const userToken = useAppUserTokenSelector();
  const eventApi = useEventApi();
  const gameDetails = useAppGameDetailsSelector();
  const [showDisplayNameModal, setShowDisplayNameModal] = useState<boolean>(false);
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);
  const [url, setUrl] = useState<any>("");
  const [promoType, setPromoType] = useState<any>("");

  const getGameDetails = () => {
    let params = {
      slug: APPLICATION_GLOBAL_SLUG,
    };
    eventApi.callGetGameDetails(
      params,
      (message: any, resp: any) => {
        // console.log({resp})
        // if(resp?.is_show_landing_page) {
        //   history.push(URLS.LANDING)
        // }
      },
      (message: any) => {}
    );
  };

  const closeGuestSaveVoteModal = () => {
    if (showGuestSaveVoteModal) setShowGuestSaveVoteModal(false);

    eventAction.resetPickIds();
    userAction.resetGuestUserId();
    localStorage.removeItem("guestUserId");
    history.push(URLS.HOME);
  };

  const onSuccessGuestSaveVoteModal = (status: boolean) => {
    if (status) {
      // console.log("APIcall")
      // saveVote()
      history.push(URLS.LOGIN);
    }
  };

  const onStatusModalClose = () => {
    setShowStatusModal(false);
  };

  const onCouponModalClose = () => {
    setShowCouponModal(false);
  };

  const closeVideoModal = () => {
    localStorage.setItem("loginPromoVidSeen", "1");
    setTimeout(() => setShowVideoModal(false), 1000);
  };

  const onStatusModalSuccess = () => {
    if (appRedirectData) {
      setShowStatusModal(false);
      let link = appRedirectData.game_info.pwa_link;
      if (link) {
        // if (userDetails && userToken) {

        window.location.href =
          link +
          (appRedirectData?.rodeo_event_id
            ? `#token=${cryptr.encrypt(appRedirectData.rodeo_event_id)}&userToken=${userToken}`
            : "");
        // }
      }
    }
  };

  //Socket Implementation start here
  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
  });

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
      let e_id = -1;
      if (eventId) {
        e_id = parseInt(cryptr.decrypt(eventId));
      }
      let guestUserId = localStorage.getItem("guestUserId");
      // console.log({e_id,changeEventStatus,guestUserId})
      if (
        changeEventStatus &&
        changeEventStatus.status == 2 &&
        changeEventStatus.rodeo_event_id == e_id &&
        guestUserId
      ) {
        // console.log(changeEventStatus)
        setShowGuestSaveVoteModal(true);
      }
    });

    socket.on(SOCKET_CHANNEL.APP_REDIRECT, (data: any) => {
      if (data.game_info.slug != APPLICATION_GLOBAL_SLUG) {
        // console.log({data})
        setShowStatusModal(true);
        setAppRedirectData(data);
      }
    });

    socket.on(SOCKET_CHANNEL.COUPON, (data: any) => {
      // console.log({data})
      setCouponData(data);
      setShowCouponModal(true);
    });

    socket.on(SOCKET_CHANNEL.IR_STATUS_MSG, (changeEventStatus: any) => {
      console.log("irStatus", changeEventStatus);
      if (changeEventStatus?.site == APPLICATION_GLOBAL_SLUG) {
        eventAction.getIrStatusMessage(changeEventStatus);
      }
    });

    //Status Message Change Socket
    socket.on(SOCKET_CHANNEL.STATUS_MESSAGE, (statusMessage: any) => {
      // console.log({statusMessage})
      if (eventId) {
        let e_id = parseInt(cryptr.decrypt(eventId));
        if (statusMessage.rodeo_event_id == e_id) {
          eventAction.setStatusMsg([statusMessage]);
        }
      }
    });

    socket.on(SOCKET_CHANNEL.PERFORMANCE_STATUS_UPDATE, (data: any) => {
      console.log({ data });
      if (performanceId) {
        let p_id = parseInt(cryptr.decrypt(performanceId));
        if (data.performance_id == p_id && data.status == 0) {
          history.push("/performances/" + eventId);
        }
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  useEffect(() => {
    // console.log({siteHeader,page})
    // let elem: any = document.getElementsByClassName("main-container")[0];
    // if (elem) {
    //   if (siteHeader != 1 || page == RODEO_PAGE_NAME.EVENT_LIST) {
    //     elem.style.paddingTop = "15px";
    //   } else {
    //     elem.style.paddingTop = "80px";
    //   }
    // }
    let parshedHash = localStorage.getItem("parshedHash");
    if (parshedHash == "1") {
      userApi.callCreateUpdateUserGame(
        {
          game_slug: APPLICATION_GLOBAL_SLUG,
        },
        (message: string, resp: any) => {
          console.log({ resp });
          localStorage.removeItem("parshedHash");
        },
        (message: string) => {}
      );
    }
  }, [siteHeader, page]);

  useEffect(() => {
    getGameDetails();
  }, []);

  const onPageChange = () => {
    if (userDetails && !userDetails.display_name) {
      // console.log({userDetails})
      setShowDisplayNameModal(true);
    }
  };

  useEffect(() => {
    onPageChange();
  }, []);

  useEffect(() => {
    if (userToken) {
      userApi.callCheckValidToken(
        (message: any, resp: any) => {
          // console.log(1,{resp})
          if (!resp) {
            // console.log(2,{resp})
            userAction.logout();
          }
        },
        (message: any, resp: any) => {
          // console.log(3,{resp})
          userAction.logout();
        }
      );
    }
  }, [page]);

  useEffect(() => {
    console.log({ page });
    let x = localStorage.getItem("loginPromoVidSeen");
    if (page == RODEO_PAGE_NAME.LOGIN && gameDetails?.promotional_video_image && x != "1") {
      let vid = gameDetails?.promotional_video_image;
      let type = vid?.file_mime.substring(0, vid?.file_mime?.indexOf("/"));
      setPromoType(type);
      setUrl(vid?.original);
      if (type == "video" || type == "image") {
        setShowVideoModal(true);
      }
    }
  }, [page, gameDetails]);

  return (
    <>
      {url && showVideoModal && promoType && (
        <VideoModal onClose={closeVideoModal} url={url} shouldShow={showVideoModal} type={promoType} />
      )}

      <TopSection page={page} />

      <SideMenus />

      {showGuestSaveVoteModal && (
        <GuestSaveVoteModal
          onClose={closeGuestSaveVoteModal}
          onSuccess={onSuccessGuestSaveVoteModal}
          shouldShow={showGuestSaveVoteModal}
        />
      )}
      {showStatusModal && appRedirectData && (
        <StatusModal
          shouldShow={showStatusModal}
          onClose={onStatusModalClose}
          onSuccess={onStatusModalSuccess}
          message={appRedirectData?.message}
          type={2}
        />
      )}
      {showDisplayNameModal && (
        <UpdateDisplayNameModal onClose={() => setShowDisplayNameModal(false)} shouldShow={showDisplayNameModal} />
      )}
      {showCouponModal &&
        couponData &&
        couponData.image &&
        (couponData.type == 1 || (couponData.type == 2 && userDetails && userDetails.id)) && (
          <CouponModal shouldShow={showCouponModal} onClose={onCouponModalClose} image={couponData.image} />
        )}
    </>
  );
}

export default Sidebar;
